import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import Avatar from "@material-ui/core/Avatar";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import Modal from "@material-ui/core/Modal";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import store from "../../../reduxstore";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SERVER_ADDRESS from "../../../config";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 2,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  button: {
    margin: theme.spacing(1),
  },
  appbar: {
    marginBottom: 1,
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      3
    )}px`,
  },
  avatar: {
    margin: theme.spacing(),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
  modal: {
    width: "350px",
    margin: "200px auto",
  },
  modalSmall: {
    width: "100%",
    margin: "80px auto",
  },
}));

//登录表单组件
function SignInForm(props) {
  const classes = useStyles();
  const { handleSubmit, formTitle, canSubmit } = props;
  //refs
  const validateRefs = {
    username: React.createRef(),
    password: React.createRef(),
  };

  const initState = { username: "", password: "" };
  const [formValue, setFromValue] = useState(initState);
  const [ilabxLoginChecked, setIlabxLoginChecked] = useState(true);

  const handleChange = (name) => (event) => {
    setFromValue({ ...formValue, [name]: event.target.value });
  };
  const handleBlur = (refname) => {
    return (event) => {
      validateRefs[refname].current.validate(event.target.value);
    };
  };

  //2 login method
  const localSubmit = handleSubmit(
    `${SERVER_ADDRESS}/api/login/`,
    formValue,
    "POST"
  );
  const ilabxSubmit = handleSubmit(
    `${SERVER_ADDRESS}/ilabx/login/`,
    formValue,
    "POST"
  );

  return (
    <Paper className={classes.paper}>
      <Avatar className={classes.avatar}>
        <LockOutlinedIcon />
      </Avatar>
      <br />
      <Typography component="h1" variant="h5">
        {formTitle ? formTitle : "登录"}
      </Typography>
      <br />
      <ValidatorForm
        className={classes.form}
        onSubmit={ilabxLoginChecked ? ilabxSubmit : localSubmit}
        instantValidate={false}
      >
        <TextValidator
          ref={validateRefs.username}
          autoFocus
          fullWidth
          label="用户名"
          onBlur={handleBlur("username")}
          onChange={handleChange("username")}
          name="username"
          value={formValue.username}
          validators={["required"]}
          errorMessages={["用户名不能为空"]}
          helperText="请填写用户名"
        />
        <TextValidator
          ref={validateRefs.password}
          fullWidth
          type="password"
          label="密码"
          onBlur={handleBlur("password")}
          onChange={handleChange("password")}
          name="password"
          value={formValue.password}
          validators={["required"]}
          errorMessages={["密码不能为空"]}
          helperText="请填写密码"
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={ilabxLoginChecked}
              color="primary"
              onChange={() => {
                setIlabxLoginChecked(!ilabxLoginChecked);
              }}
              value="useIlabX"
            />
          }
          label="支持使用实验空间账号登录"
        />
        {/* <p>评审账号：testStudent</p>
        <p>密码：qgsTest002</p>
        <br /> */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          type="submit"
          disabled={!canSubmit}
        >
          {canSubmit ? "登录" : "登录中···"}
        </Button>
        <Button
          fullWidth
          color="primary"
          className={classes.submit}
          type="button"
          onClick={() => {
            window.open("http://www.ilab-x.com/register");
          }}
        >
          注册实验空间账号
        </Button>
        <Button
          fullWidth
          color="primary"
          type="button"
          onClick={() => {
            window.open("http://162.105.209.225/fzsy/1174.jhtml");
          }}
        >
          北京大学实验教学资源共享平台跳转登录
        </Button>
      </ValidatorForm>
    </Paper>
  );
}

//登录弹出Modal组件，需要其他情况下复用
function LoginModal(props) {
  const classes = useStyles();
  const [canSubmit, setCansubmit] = useState(true);
  const { open, handleClose, formTitle } = props;
  //使用媒介查询,改变登录对话框出现位置
  const matches = useMediaQuery("(min-width:600px)");
  //发送登录数据
  const handleSubmit = (postUrl, formValue, method) => {
    return (e) => {
      e.preventDefault();
      setCansubmit(false);
      let h = new Headers();
      h.append("Accept", "application/*");
      let formdata = new FormData();
      Object.keys(formValue).forEach((value) => {
        formdata.append(value, formValue[value]);
      });

      let req = new Request(postUrl, {
        method: method,
        headers: {
          Accept: "application/*, text/plain, */*",
        },
        mode: "cors",
        credentials: "include",
        body: formdata,
      });

      fetch(req)
        .then((res) => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.json();
        })
        .then((data) => {
          //关闭登录框
          handleClose();
          //提交成功后的反馈SnackBar
          props.enqueueSnackbar("登陆成功", {
            variant: "success",
          });
          store.dispatch({ type: "UPDATEAccount", account: data });
        })
        .catch((error) => {
          //失败后显示错误SnackBar
          // console.log(error);
          setCansubmit(true);

          props.enqueueSnackbar("登录失败，账号或密码错误", {
            variant: "error",
          });
        });
    };
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={matches ? classes.modal : classes.modalSmall}
    >
      <SignInForm
        handleSubmit={handleSubmit}
        formTitle={formTitle}
        canSubmit={canSubmit}
      />
    </Modal>
  );
}

export default withSnackbar(LoginModal);
